import { Typography, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export interface IErrorMessageProps {
	isValidationError: boolean | string;
	startDateInvalid: boolean | undefined;
	endDateInvalid: boolean | undefined;
	label: string | undefined;
}
export default function DatePickerErrorMessage(props: IErrorMessageProps) {
	const { palette } = useTheme();
	const { t } = useTranslation();

	if (props.isValidationError || props.startDateInvalid || props.endDateInvalid) {
		return (
			<Typography
				variant="caption"
				style={{
					color: palette.error.dark,
					position: "absolute",
					left: "0",
					bottom: "-15px",
					fontSize: "9px",
					whiteSpace: "nowrap",
				}}
			>
				{props.isValidationError ? t(props.label || "time-period") : t("invalid-date")}
			</Typography>
		);
	}
	return <></>;
}
